module.exports = __webpack_public_path__ + "static/media/qmsj_swiper.ab743ba1.jpg";